import { Navigate, Route, Routes } from "react-router-dom";
import { Shell } from "./components/layout/shell";
import { AuditLogPage } from "./pages/audit-log";
import { ConfiguracoesPage } from "./pages/configuracoes";
import { ConvitesPage } from "./pages/convites";
import { DashboardPage } from "./pages/dashboard";
import { LoginPage } from "./pages/login";
import { SolicitacoesPage } from "./pages/solicitacoes";
import { UsuariosPage } from "./pages/usuarios";

export function Rotas() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<Shell />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="convites" element={<ConvitesPage />} />
        <Route path="solicitacoes" element={<SolicitacoesPage />} />
        <Route path="usuarios" element={<UsuariosPage />} />
        <Route path="audit-log" element={<AuditLogPage />} />
        <Route path="configuracoes" element={<ConfiguracoesPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
